import { Identifiable } from "./identifiable";
import { Task } from "./task";
import { Tag } from "./tag";
import { Milestone } from "./milestone";
import { Event } from "./event";
import { Attachment } from "./attachment";

type List = {
  name: string;
  description: string;
  startDate: string;
  endDate: string;
  createdDate: string;
  parentList?: Identifiable<List>;
  subLists: Identifiable<List>[];
  tasks: Identifiable<Task>[];
  events: Identifiable<Event>[];
  milestones: Identifiable<Milestone>[];
  tags: Tag[];
  attachments?: Identifiable<Attachment>[];
  commentsNbr?: number;
  attachmentsNbr?: number;
  activityKeyRank: number;
  statusKeyRank: number;
  attributes?: { [key: string]: string };
  minStartDate: string;
  maxStartDate: string;
  minEndDate: string;
  maxEndDate: string;
};

const list: List = {
  description: "",
  name: "",
  startDate: "",
  endDate: "",
  createdDate: "",
  subLists: [],
  tasks: [],
  events: [],
  tags: [],
  milestones: [],
  activityKeyRank: 0,
  statusKeyRank: 0,
  minStartDate: "",
  maxStartDate: "",
  minEndDate: "",
  maxEndDate: "",
};

export type { List };

export { list };
